import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import React, {useEffect} from "react";
import {useState} from "react";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoDateInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoDateInputOutlined";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";
import {SpecialNewsService} from "./SpecialNewsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";

const SpecialNewsDetailBaseInfo = ({id}) => {

    const service = new SpecialNewsService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            getDataFromServer()
        }
    }, [id])

    function getDataFromServer() {
        loading.show()
        service.getSpecialNewsDetail(id)
            .then(({globalInfo, published}) => {

                setPublished(published.published)

                setTitle(globalInfo.title)
                setNewsLink(globalInfo.link)
                setCreatedAt(convertUniversalDateToPersianDate(globalInfo.createdAt))
                setCreatedBy(globalInfo.createdBy)

                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات خبر ویژه."))
            loading.hide()
        })
    }

    const [title, setTitle] = useState("")
    const [newsLink, setNewsLink] = useState("")
    const [createdBy, setCreatedBy] = useState("")
    const [createdAt, setCreatedAt] = useState("")


    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);
    const [published, setPublished] = useState(true);

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleChangeEnableSetting() {
        loading.show()
        service.updatePublishedState(id, !published)
            .then(response => {
                setPublished(response.published)
                handleCloseConfirmDialog()
                snackbar.showSuccessMessage("بروزرسانی وضعیت انتشار با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی وضعیت انتشار"))
            loading.hide()
        })
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }


    function handleUpdateGlobalInfo() {
        loading.show()
        service.updateGlobalInfo(id, title, newsLink)
            .then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی جزئیات خبر ویژه."))
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار مقاله"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!published ? "انتشار" : "عدم انتشار"}
            />
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات پایه"}/>
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان خبر"}
                                setValue={setTitle}
                                value={title}
                            /><RaikoSimpleInputOutlined
                            labelText={"لینک خبر"}
                            setValue={setNewsLink}
                            value={newsLink}
                        />
                        </RaikoGridTwoColumn>
                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateGlobalInfo}/>
                        </ButtonDivisionSection>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات ساخت"}/>
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"ساخته شده توسط"}
                                setValue={setCreatedBy}
                                value={createdBy}
                                disabled={true}
                            />
                            <RaikoDateInputOutlined
                                labelText={"تاریخ ساخت"}
                                setValue={setCreatedAt}
                                value={createdAt}
                                disabled={true}
                            />
                        </RaikoGridTwoColumn>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"وضعیت انتشار"}
                            description={[
                                "* با فعالسازی این مورد کاربران قادر به مشاهده ی این خبر ویژه خواهند بود و در غیر این صورت خبر ویژه تنها به عنوان پیش نمایش در پنل مدیریت باقی خواهند ماند.",
                            ]}
                        />
                        <RaikoToggleOutlined
                            labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                            setChecked={state => {
                                handleOpenConfirmDialog()
                            }}
                            checked={published}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>


        </>
    )
}
export default SpecialNewsDetailBaseInfo;